import Axios from 'axios';
import config from '../../config.js';
import { ICustomer } from '@/domain/ICustomer';
import store from '@/store';
import i18n from '@/i18n';
import Vue from 'vue';

export abstract class AccountApi {
    private static axios = Axios.create({
        baseURL: config.API_URL,
        headers: {
            common: {
                'Content-Type': 'application/json'
            }
        }
    });

    private static encodeQueryParam(value: string | number | null | undefined): string {
        return encodeURIComponent(String(value ?? ''));
    }

    static async getCustomerInfo(customerId: number): Promise<ICustomer | null> {
        let url = '/customerinfo?lang=' + this.encodeQueryParam(i18n.locale);
        if (customerId !== null) {
            url += '&customerid=' + this.encodeQueryParam(customerId);
        }
        const encodedToken = store.state.token;
        const mydata = {
            customerid: null,
            firstname: null,
            lastname: null,
            companyname: null,
            title: null,
            personal_code: null,
            customertype: null,
            invoiceextrafields: false,
            preferred_language: null,
            website: null,
            registration_code: null,
            vat_code: null,
            bp_collected: null,
            bp_valid: null,
            contract_details: null,
            role: null,
            authorizers: [],
            contacts: [],
            addresses: [],
            customer_categories: [],
            customer_cards: [],
            customer_manager: null,
            sales_persons: [],
            authorized_persons: [],
            travel_managers: [],
            last_modified: null,
            bonus_cards: null,
            parent_companies: [],
            subsidiaries: [],
            birth_date: null,
            gender: null
        };
        try {
            const response = await this.axios.get<typeof mydata>(url, { headers: { 'Authentication-Estravel': 'Bearer ' + encodedToken } });
            if (response.status === 200) {
                return response.data;
            } else if (response.status === 401) {
                Vue.notify({
                    group: 'auth',
                    title: i18n.t('account_login.access_denied_title') as string,
                    text: i18n.t('account_login.access_denied_text') as string,
                    type: 'warn'
                });
                return null;
            }
            return null;
        } catch (error) {
            console.error('error: ', (error as Error).message);
            Vue.notify({
                group: 'auth',
                title: i18n.t('account_login.switch_role_failed_title') as string,
                text: (error as Error).message,
                type: 'warn'
            });
            return null;
        }
    }
}
